import React from 'react';

import {
  CarsListHeaderWrapper,
  CarsListHeaderLeft,
  CarsListHeaderRight,
} from '@/modules/CarsStock/components/common.styles';

import CarsFilterResult from './components/CarsFilterResult';
import ViewToggle from './components/ViewToggle';
import Sorting from './components/Sorting';
import { CarsListHeaderProps } from './types';

function CarsListHeader({ carsType }: CarsListHeaderProps) {
  return (
    <CarsListHeaderWrapper id="carsListHeader">
      <CarsListHeaderLeft>
        <CarsFilterResult />
      </CarsListHeaderLeft>

      <CarsListHeaderRight>
        <Sorting carsType={carsType} />
        <ViewToggle />
      </CarsListHeaderRight>
    </CarsListHeaderWrapper>
  );
}

export default CarsListHeader;
